import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=1aa961de&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=1aa961de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa961de",
  null
  
)

export default component.exports